import { exchangePair } from '../api/pair';
import { userMessage } from '../api/client';
import { setToken } from '../auth/session';
import { el, showToast } from '../ui/dom';

async function completePair(body: { pair_token?: string; short_code?: string }): Promise<void> {
  const r = await exchangePair(body);
  setToken(r.phone_token);
  // Full navigation — synthetic popstate is unreliable in phone QR browsers.
  const n =
    r.phones_limit != null ? `${r.phones_connected}/${r.phones_limit}` : String(r.phones_connected);
  window.location.replace(`/devices?paired=1&n=${encodeURIComponent(n)}`);
}

export function renderPair(root: HTMLElement, pairToken: string | null): void {
  root.innerHTML = '';
  const page = el('div', { className: 'connect-page' });
  page.append(el('h1', {}, 'Pair this phone'));

  if (pairToken) {
    page.append(el('p', { className: 'muted' }, 'Connecting…'));
    root.append(page);
    void completePair({ pair_token: pairToken }).catch((e) => {
      page.innerHTML = '';
      page.append(
        el('p', {}, userMessage(e)),
        el('a', { className: 'btn secondary', href: '/connect' }, 'Help'),
      );
    });
    return;
  }

  page.append(
    el('p', {}, 'Scan the QR code on your Remindo (Settings → Device → Web settings).'),
    el('p', { className: 'muted' }, 'Or enter a 6-digit code if you have one from an older pairing flow.'),
  );

  const codeInput = el('input', {
    className: 'field',
    type: 'text',
    inputmode: 'numeric',
    maxlength: '6',
    placeholder: '000000',
    'data-testid': 'pair-short-code',
  }) as HTMLInputElement;

  const btn = el('button', { className: 'btn', 'data-testid': 'pair-submit' }, 'Connect') as HTMLButtonElement;
  btn.onclick = async () => {
    const short_code = codeInput.value.trim();
    if (short_code.length !== 6) {
      showToast('Enter 6-digit code');
      return;
    }
    btn.disabled = true;
    try {
      await completePair({ short_code });
    } catch (e) {
      showToast(userMessage(e));
      btn.disabled = false;
    }
  };

  page.append(codeInput, btn, el('a', { className: 'btn secondary', href: '/connect', style: 'display:block;margin-top:12px;' }, 'Help'));
  root.append(page);
}

/** First-time device setup — full flow ships with firmware Pair screen (W1). */
export function renderSetup(root: HTMLElement): void {
  root.innerHTML = '';
  root.append(
    el('div', { className: 'connect-page' }, [
      el('h1', {}, 'Set up Remindo'),
      el('p', {}, 'Complete Wi‑Fi and family setup on your Remindo screen first.'),
      el('div', { className: 'card' }, [
        el('h2', {}, 'Then pair this phone'),
        el('p', {}, 'On your Remindo: Settings → Device → Web settings, then scan the QR code with this phone.'),
        el('a', { className: 'btn', href: '/pair' }, 'Open pair page'),
      ]),
      el('a', { className: 'btn secondary', href: '/connect', style: 'display:block;margin-top:12px;' }, 'Help'),
    ]),
  );
}
